define([
    'vue',
    'vueI18n',
    'WebI18N/config/zh.js',
    'WebI18N/config/en.js'
], function(
    Vue,
    VueI18n,
    zh,en
){
    Vue.use(VueI18n);

    var i18n = new VueI18n({
        //设置默认语言
        locale: localStorage.getItem('locale')||'zh',//语言标识
        //添加多语言（每一种语言对应一个语言文件）
        messages: {
            zh:zh,//中文
            en:en//英文
        }
    });
    //暴露i18n
    return i18n;
});


//////////////////
// WEBPACK FOOTER
// ../i18n/index.js
// module id = 17
// module chunks = 0 1 2 3 4 5 6 7 8